// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-table {
    border-collapse: collapse;
    width: 100%;
  }
  
  .invoice-table th,
  .invoice-table td {
    border: 0.5px solid #000000;
    padding: 8px;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/Hotels/HotelBill.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;EACb;;EAEA;;IAEE,2BAA2B;IAC3B,YAAY;EACd","sourcesContent":[".invoice-table {\n    border-collapse: collapse;\n    width: 100%;\n  }\n  \n  .invoice-table th,\n  .invoice-table td {\n    border: 0.5px solid #000000;\n    padding: 8px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
